export const BREAKPOINT_MOBILE = 1024
